import axios from "axios";

export const loginUser = async (username, password) => {
  try {
    const response = await axios.post(
      `${process.env.REACT_APP_API_BASE_URL}/mobile/login`,
      {
        username,
        password,
      }
    );
    return response.data;
  } catch (error) {
    console.error("Login API Error:", error);
    throw (
      error.response?.data || { status: false, message: "An error occurred" }
    );
  }
};
